import React, { useContext } from 'react';

import { PaginationWrapper, PaginationElement } from '../elements';
import AppContext from '../context/index';

export const Pagination = ({ isFirst, isLast, prevPage, nextPage }) => {
  const { dark } = useContext(AppContext);
  return (
    <PaginationWrapper isFirst={isFirst} isLast={isLast} dark={dark}>
      <PaginationElement to={prevPage}>Previous Page</PaginationElement>
      <PaginationElement to={nextPage}>Next Page</PaginationElement>
    </PaginationWrapper>
  );
};
